export default "__VITE_ASSET__BgTdmCrU__"